module.exports = __webpack_public_path__ + "static/media/foodtransport2 (1).24340a9b.jpg";